/**
=========================================================
* Astro Clean Carpets - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Astro Clean Carpets base styles
import borders from "assets/theme/base/borders";

// Astro Clean Carpets helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { borderRadius } = borders;

const themeConfig = { styleOverrides: {
  root: {
    display: "block",
    padding: `${pxToRem(16)} ${pxToRem(16)} 0  ${pxToRem(16)}`,
    borderRadius: `${borderRadius.xl} ${borderRadius.xl} 0 0`,
  },
}, }
export default themeConfig;
